import { IRollObject } from "../../../../../domain/editableFormat/objects";
import { IRollObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { SelectableObjectTranslator } from "./base";
import { RollSelectBehaviorTranslator } from "./properties";

export class RollObjectTranslator extends AbstractObjectTranslator<IRollObject, IRollObjectBean> {
  constructor() {
    super(new SelectableObjectTranslator());
  }

  protected shouldRecordName(source: IRollObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IRollObject, bean: IRollObjectBean, formatId: number): void {
    source.rollSelectBehavior = this.rollSelectBehavior.from(bean);
  }

  overwriteBean(source: IRollObjectBean, object: IRollObject): void {
    source.rollitem = this.rollSelectBehavior.to(object.rollSelectBehavior).rollitem;
  }

  private readonly rollSelectBehavior = new RollSelectBehaviorTranslator();
}
